import React, { useState } from "react";
import { Intro } from "pages/Intro";
import { Main } from "pages/Main";

export const Home: React.FC = () => {
  const [isHome, setIsHome] = useState(true);

  return <>{isHome ? <Intro setIsHome={setIsHome} /> : <Main />}</>;
};
